import React from 'react';
import css from '@emotion/css';
import { Button } from 'antd';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';
import { observer, inject } from 'mobx-react';

@inject('settingsStore')
@inject('onboardingStore')
@observer
class Welcome extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    minimizeWizard() {
      this.timerHandle = setTimeout(() => {
        this.props.onboardingStore.toggleWizard();
        this.timerHandle = 0;
      }, 200);
    }

    render() {

        const {
        onboardingStore:{
          setOpenCourseFromOnboarding,
          setPromotionModalOpen
        }
        } = this.props;

        return(
          <div
            css={css`
              padding:10px 30px;
              font-size:18px;
              margin-left:50px;
              margin-top:-12px;
              `
            }
          >
            <div css={css`padding:20px 0;`}>
              <FormattedMessage id="onboarding.screen0.new" />
              <div
                css={css`
                  display:flex;
                  justify-content:center;
                  margin-top:10px;
                  margin-bottom:-15px;
                `}
              >
                <Link
                  onClick={() =>{
                  this.minimizeWizard()
                  setOpenCourseFromOnboarding(true)
                  setPromotionModalOpen(true)
                  }}
                  to="/learning"
                >
                  <Button>
                    <FormattedMessage id="onboarding.buttons.course" />
                  </Button>
                </Link>
              </div>
            </div>
            <div css={css`padding:10px 0;`}>
              <FormattedMessage id="onboarding.screen0.dropshipper" />
              <FormattedMessage id="onboarding.screen0.dropshipper1" />
            </div>
          </div>
        )

    }

}

Welcome.propTypes = {
};

export default Welcome;